"use client"

import { GoToCheckoutButton } from "src/components/cart/GoToCheckoutButton"
import { useCartState } from "src/components/checkout/hooks/useCart"
import { Icon } from "src/components/generic/Icon"
import { freeShippingThreshold } from "src/data/feeds/shipping"
import { formatPriceShort } from "src/utilities/price"

export const CartSidebarFooter = () => {
  const { data: cart } = useCartState()

  const total = +(cart?.totals.total_price || 0) / 100
  const freeShippingRatio = total / freeShippingThreshold
  const shippingIsFree = freeShippingRatio >= 1

  const freeShippingText =
    "Gratis Versand innerhalb Deutschlands" +
    (shippingIsFree ? "" : " ab " + formatPriceShort(freeShippingThreshold) + " Bestellwert")

  const freeShippingInfo = (
    <div className="flex items-center justify-center gap-2 text-center">
      <Icon name="package" className="size-8" />
      {freeShippingText}
    </div>
  )

  return (
    <footer className="bg-np-green10 w-full p-4 lg:p-6">
      <div className="flex flex-col gap-4 lg:gap-6">
        <GoToCheckoutButton />
        {freeShippingInfo}
      </div>
    </footer>
  )
}
